(function () {
  function initMobileDrawer() {
    document.querySelectorAll('[data-tp-mobile-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        var topDetails = button.closest('.tp-mobile-top');
        if (topDetails) {
          topDetails.removeAttribute('open');
        }
      });
    });

    document.querySelectorAll('.tp-mobile-top').forEach(function (topDetails) {
      topDetails.addEventListener('toggle', function () {
        if (!topDetails.open) {
          topDetails.querySelectorAll('.tp-mobile-category[open]').forEach(function (category, index) {
            if (index !== 0) {
              category.removeAttribute('open');
            }
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initMobileDrawer);
})();